import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpacePostTypesKey } from '../../utils/keys';
export const useSpacePostTypes = (options) => {
    const { variables, fields = 'default', useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const spacePostTypesKey = getSpacePostTypesKey({ variables, fields });
    return useInfiniteQuery(spacePostTypesKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.spacePostType.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useSpacePostTypes.js.map